export default __webpack_public_path__ + "static/media/logo.3c0a68f1.png";